import { Auth } from 'aws-amplify'
import axios from 'axios'
import UserRoleAPI from './UserRoleAPI'
import UserRoleAPIMethod from './UserRoleAPIMethod'
import { reject } from 'q'

class UserRolesService {
    constructor() {
        //this.updateUserRoles()
    }

    /** fetch using the cognito roleId the user's roles
     *    
     *    @return Promise
     */
    updateUserRoles() : Promise<any[]> {
        console.log('UserRoleService::updateUserRoles()')
        return new Promise((resolve, reject) => {
            Auth.currentAuthenticatedUser({
                bypassCache: true // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
            })
                .then(user => {
                    console.log('Header::amplify auth user', user)

                    // also refresh the current roles for this user
                    let roleId = (user && user.attributes['custom:roleId']) || null
                    axios.get('/role/' + roleId + '?useLoggedPartner=true').then(response => {
                        // store roles for this user to be used later to enable/disable buttons
                        window.localStorage.partnerRoles = JSON.stringify(response.data.body || [])
                        resolve(response.data.body)
                    })
                })
                .catch(err => {
                    console.log('Header::amplify auth user error:', err)
                    reject()
                })
        })
    }

    /** return json parsed list of user roles from localstorage
     *
     *    @return Promise
     */
    getUserRoles(): Promise<UserRoleAPI[]> {
        return new Promise<any[]>(resolve => {
            let currentUserRoles = null
            try{
                currentUserRoles = JSON.parse(window.localStorage.partnerRoles)
            }catch(e){
                reject(e)
            }
            if (currentUserRoles == null) {
                this.updateUserRoles().then((userRoles: any[]) => {
                    resolve(userRoles)
                })
            } else {
                resolve(currentUserRoles)
            }
        })
    }

    /**
     * Check if the current user is enabled to use a specific api and method.
     * 
     * This can be used directly like: 
     *      <div className={(this.UserService.isEnabled('/audience', 'DELETE')) ? 'show' : 'hide'} ...>...</div>
     * 
     * Or it can be used with a component that wraps other nodes and that hides children 
     * nodes from rendering if the condition is not true:
     * 
     *      <ACLCheckPermission api="/audience" method="DELETE">...</ACLCheckPermission>
     * 
     *  @return Promise
     */
    isEnabled(api: string, method: string) : Promise<boolean>{
        return new Promise(resolve => {
            this.getUserRoles().then((userRoles : UserRoleAPI[]) => {
                let _api:UserRoleAPI = userRoles.find(el => el.api === api) as UserRoleAPI
                if(_api){
                    let _method : UserRoleAPIMethod = _api.methods.find(el => el.method === method) as UserRoleAPIMethod
                    if(_method && _method.active === true){
                        resolve(true)
                    } else if(_method && _method.active === false){
                        resolve(false)
                    }
                }
                resolve(false)
            })
        })
    }
}

export default UserRolesService
